/*
 * Copyright (c) 2021. DDMIX - All Rights Reserved.
 * This source code can not be copied and/or distributed without the express permission of DDMIX.
 *
 * Written by Jake Lee <leejaku@gmail.com>
 */

import axios from 'axios';

export class ObixUtil {
    // obix로 주어진 객체에서 name에 해당하는 객체를 넘김. 없으면 빈 객체
    static find(obix, name) {
        // obix는 json 타입의 객체임
        var child;
        if (Array.isArray(obix)) {
            child = obix;
        } else {
            child = obix.c;
        }
        if (child) {
            for (const element of child) {
                if (element.name === name) {
                    return element;
                }
            }
        }
        return {};
    }

    // 여러개의 후보 중에서 찾음
    static findAny(obj, array) {
        if (!obj) return undefined;
        if (!(obj instanceof Map)) {
            console.error("Argument obj should be Map. use ObixUtil.cmap()");
            return undefined;
        }

        //console.log(typeof obj);
        //console.dir(obj);  // Map 이 넘어옴
        if (array instanceof Array) {
            for (const name of array) {
                if (obj.get(name)) {
                    return obj.get(name);
                }
            }
        } else {  // 그냥 string 하나면
            return obj.get(array);
        }
        return undefined;
    }

    // child 항목을 검색하기 쉽게 Map으로 만들어줌
    static cmap(obix) {
        var child;
        if (Array.isArray(obix)) {
            child = obix;
        } else {
            child = obix.c;
        }
        var map = new Map();
        if (child) {
            for (const row of child) {
                //map[row.name] = row;
                map.set(row.name, row);
            }
        }
        return map;
    }

    // Obix를 Javascript object로 변환함.
    static toObj(obix) {
        var child;
        if (Array.isArray(obix)) {
            child = obix;
        } else {
            child = obix.c;
        }

        var o = {};
        if (child) {
            for (const row of child) {
                o[row.name] = row.val;
            }
        }
        return o;
    }

    static getErrorMsg(obix) {
        var child;
        if (Array.isArray(obix)) {
            child = obix;
        } else {
            child = obix.c;
        }
        if (child && child[0]?.o === "err") {  // invokeObix가 일반 json을 리턴할 때는 .o 항목이 없음.
            return /*child[0].is[0] + "=>" + */child[0].display;
        } else {
            return null;
        }
    }

    // 인자로 App.js에 있는 objMap을 받음
    // 예를 들어 pcs/1/pcs/p 가 pcsUri에 등록되어 있다고 하자...
    // 그러면 pcs/1/pcs 도 같이 값이 가져와서, 둘 다 있으면 최근 것 (__time__ 으로 구분)을 취함
    // 호출 예:  getRecent(props.objmap, 'pcs/1/pcs/p', 'acVoltage')
    static getRecent(objmap, href, propName) {
        let cmap = objmap.get(href);
        let ts = cmap?.get('__time__').val;
        let cmap2 = null;
        let href2 = null;
        let ts2 = 0;
        //console.log(`href=${href}, propName=${propName}`);
        if (!href) return null;
        if (href.endsWith("/p")) {
            href2 = href.substring(0, href.length-2);  // 뒤에 /p를 떼냄
            cmap2 = objmap.get(href2);
            if (cmap2)
                ts2 = cmap2.get('__time__').val;
        }
        //console.log(`ts=${ts}, ts2=${ts2}`);
        if (cmap && !cmap2) {
            return cmap.get(propName);
        } else if (!cmap && cmap2) {
            return cmap2.get(propName);
        } else if (cmap && cmap2) {
            let row = cmap.get(propName);
            let row2 = cmap2.get(propName);
            if (row && !row2) {
                return row;
            } else if (!row && row2) {
                return row2;
            } else if (row && row2) {
                // 둘다 있으면 최신 것을 보낸다.
                if (ts > ts2) return row;
                else return row;
            } else {
                return null;
            }
        } else {
            return null;
        }
    }

    // Date 인자를 받아서 XML Date 형식으로 바꿈.
    // Javascript 기본은 GMT 기준으로 바꿔서, 헷갈림.
    // Timestamp를 떼던가... 아예 UTC+9 로 바꾸어줌.
    static toIsoDate(d) {
        if (d) {
            //console.log(`type = ${typeof d}`);
            return `${d.getFullYear()}-${d.getMonth()+1}-${d.getDate()}T${d.getHours()}:${d.getMinutes()}:${d.getSeconds()}`;
        } else {
            return '';
        }
    }

    // localStorage를 찾아서 인증되었는지, token이 있는지 확인함.
    //TODO: 적어도 JWT format을 regex로 테스트는 하자.
    static authenticated() {
        const token = window.localStorage["mm_token"];
        if (token) return true;
        else return false;
    }

    /**
     * Callback for onSuccess
     *
     * @callback onSuccess
     * @param {Object} resp - resp object
     */

    /**
     * Callback for onFail
     *
     * @callback onFail
     * @param {string} err - error message
     */

    //TODO: Cookie로 하게 될것이므로 Authorization은 빼자.
    static readObix(url, onSuccess, onFail) {
        const storedToken = window.localStorage["mm_token"];
        axios.get(url, { headers: { "Accept": "application/json", 'X-HTTP-METHOD-OVERRIDE': 'GET', "Authorization": `Bearer ${storedToken}` } })
        .then((resp) => {
            let errmsg = ObixUtil.getErrorMsg(resp.data);
            if (errmsg) {
                onFail(errmsg);
            } else {
                onSuccess(resp);
            }
        }).catch((error) => {
            if (error.response?.status === 401) {
                window.localStorage["mm_token"] = "";
                console.log("token cleared for 401");
                setTimeout(() => window.location.href='/login', 500);  // 바로 reload하면 안되어서, timer 줌
                return;
            }
            let errmsg = error.response?.status + "=>" + error.message;
            onFail(errmsg);
        });
    }

    static readObixXml(url, onSuccess, onFail) {
        const storedToken = window.localStorage["mm_token"];
        axios.get(url, { headers: { "Accept": "text/xml", 'X-HTTP-METHOD-OVERRIDE': 'GET', "Authorization": `Bearer ${storedToken}` } })
        .then((resp) => {
            let errmsg = ObixUtil.getErrorMsg(resp.data);
            if (errmsg) {
                onFail(errmsg);
            } else {
                onSuccess(resp);
            }
        }).catch((error) => {
            if (error.response?.status === 401) {
                window.localStorage["mm_token"] = "";
                console.log("token cleared for 401");
                setTimeout(() =>  window.location.href='/login', 500);  // 바로 reload하면 안되어서, timer 줌
                return;
            }
            let errmsg = error.response?.status + "=>" + error.message;
            onFail(errmsg);
        });
    }

    /**
     * API 결과를 저장하도록 하는 요청
     * #75 download 에 Authorization 넣을 수 있도록 추가함.
     * @param {string} url
     * @param {string} filename
     * @param {onSuccess} onSuccess
     * @param {onFail} onFail
     */
    static readObixDownload(url, filename, onSuccess, onFail) {
        const storedToken = window.localStorage["mm_token"];
        axios.get(url, { headers: { 'X-HTTP-METHOD-OVERRIDE': 'GET', "Authorization": `Bearer ${storedToken}` }, responseType: 'blob' })
        .then((resp) => {
            //header content-disposition에서 filename 추출.
            console.dir(resp);
            let name = filename;
            if (!name)
                name = resp.headers['content-disposition'].split('filename=')[1];
            //IE 이외 다운로드 처리
            const url = window.URL.createObjectURL(new Blob([resp.data], { type: resp.headers['content-type'] }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', name);
            document.body.appendChild(link);
            link.click();
            onSuccess(resp);
            document.body.removeChild(link);
            //delete link;
        }).catch((error) => {
            if (error.response?.status === 401) {
                window.localStorage["mm_token"] = "";
                console.log("token cleared for 401");
                setTimeout(() =>  window.location.href='/login', 500);  // 바로 reload하면 안되어서, timer 줌
                return;
            }
            let errmsg = error.response?.status + "=>" + error.message;
            onFail(errmsg);
        });
    }

    /**
     * CSV를 다운받는 API 요청
     * @param {string} url
     * @param {Object} body
     * @param {string} filename
     * @param {function(Object)} onSuccess
     * @param {function(string)} onFail
     */
    static invokeCsvDownload(url, body, filename, onSuccess, onFail) {
        const storedToken = window.localStorage["mm_token"];
        axios.post(url, body, { headers: { 'X-HTTP-METHOD-OVERRIDE': 'POST',  "Accept": "text/csv", "Authorization": `Bearer ${storedToken}` }, responseType: 'blob' })
        .then((resp) => {
            //header content-disposition에서 filename 추출.
            console.dir(resp);
            let name = filename;
            if (!name)
                name = resp.headers['content-disposition'].split('filename=')[1];
            //IE 이외 다운로드 처리
            const url = window.URL.createObjectURL(new Blob([resp.data], { type: resp.headers['content-type'] }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', name);
            document.body.appendChild(link);
            link.click();
            onSuccess(resp);
            document.body.removeChild(link);
            //delete link;
        }).catch((error) => {
            if (error.response?.status === 401) {
                window.localStorage["mm_token"] = "";
                console.log("token cleared for 401");
                setTimeout(() =>  window.location.href='/login', 500);  // 바로 reload하면 안되어서, timer 줌
                return;
            }
            let errmsg = error.response?.status + "=>" + error.message;
            onFail(errmsg);
        });
    }

    // url = full URL을 줘야 함. energleContext.sgurl 포함
    // body = write body
    // onSuccess()
    // onFail(msg)
    static writeObix(url, body, onSuccess, onFail) {
        const storedToken = window.localStorage["mm_token"];
        let rbody = body;
        if (Array.isArray(body)) {  // 위 껍데기 안 썼을 경우에도
            rbody = {
                o: "obj",
                c: body
            }
        }
        axios.post(url, rbody, { headers: { "Accept": "application/json", 'X-HTTP-METHOD-OVERRIDE': 'PUT', "Authorization": `Bearer ${storedToken}` } })
            .then((resp) => {
                let errmsg = ObixUtil.getErrorMsg(resp.data);
                if (errmsg) {
                    onFail(errmsg);
                } else {
                    onSuccess(resp);
                }
            }).catch((error) => {
                if (error.response?.status === 401) {
                    window.localStorage["mm_token"] = "";
                    console.log("token cleared for 401");
                    setTimeout(() =>  window.location.href='/login', 500);  // 바로 reload하면 안되어서, timer 줌
                    return;
                }
                let errmsg = error.response?.status + "=>" + error.message;
                onFail(errmsg);
            });
    }

    static invokeObix(url, body, onSuccess, onFail) {
        const storedToken = window.localStorage["mm_token"];
        let rbody = body;
        if (Array.isArray(body)) {  // 위 껍데기 안 썼을 경우에도
            rbody = {
                o: "obj",
                c: body
            }
        }
        axios.post(url, rbody, { headers: { "Accept": "application/json", 'X-HTTP-METHOD-OVERRIDE': 'POST', "Authorization": `Bearer ${storedToken}` } })
        .then((resp) => {
            let errmsg = ObixUtil.getErrorMsg(resp.data);
            if (errmsg) {
                onFail(errmsg);
            } else {
                onSuccess(resp);
            }
        }).catch((error) => {
            if (error.response?.status === 401) {
                window.localStorage["mm_token"] = "";
                console.log("token cleared for 401");
                setTimeout(() =>  window.location.href='/login', 500);  // 바로 reload하면 안되어서, timer 줌
                return;
            }
            let errmsg = error.response?.status + "=>" + error.message;
            onFail(errmsg);
        });
    }

    static normalizeKilo(child, decimal=0, showUnit=true) {  // 단위를 kW, kVAR 등으로 바꿈
        if (!child) return "";
        let val = child.val;
        let u = child?.u;
        if (child.u === 'W') {
            val /= 1000;
            u = 'kW';
        } else if (child.u === 'VAR') {
            val /= 1000;
            u = 'kVAR';
        } else if (child.u === '\u2126') {
            val /=1000;
            u = 'kΩ'
        }
        val = Math.round(val*(10**decimal))/(10**decimal);
        val = val.toLocaleString('en');
        if (u && showUnit)
            return val + ' ' + u;
        else
            return val;
    }

    static normalize(child, decimal=0, showUnit=true) {  // 정수로
        if (!child) return "";
        let val = child.val;
        let u = child?.u;
        val = Math.round(val*(10**decimal))/(10**decimal);
        val = val.toLocaleString('en');
        if (u && showUnit)
            return val + ' ' + u;
        else
            return val;
    }

    static normalizeInt(child, showUnit=true) {  // 정수로
        if (!child) return "";
        let val = child.val;
        let u = child?.u;
        val = Math.round(val);
        val = val.toLocaleString('en');
        if (u && showUnit)
            return val + ' ' + u;
        else
            return val;
    }

    static normalizePoint1(child, showUnit=true) {  // 한자리
        if (!child) return "";
        let val = child.val;
        let u = child?.u;
        val = Math.round(val * 10) / 10;
        if (u && showUnit)
            return val + ' ' + u;
        else
            return val;
    }

    static normalizePoint2(child, showUnit=true) {  // 두자리
        if (!child) return "";
        let val = child.val;
        let u = child?.u;
        if (child.u === '%') {
            val /= 100;
            u = 'pf';
        }
        val = Math.round(val * 100) / 100;
        if (u && showUnit)
            return val + ' ' + u;
        else
            return val;
    }

    static normalizePoint3(child, showUnit=true) {  // 세자리
        if (!child) return "";
        let val = child.val;
        let u = child?.u;
        val = Math.round(val * 1000) / 1000;
        if (u && showUnit)
            return val + ' ' + u;
        else
            return val;
    }

    /**
     * Camel Case로 된 스트링을 보기좋게 바꿈.
     * dcOverVoltage => DC Over Voltage
     * @param {*} f
     * @returns
     */
    static humanizeCamelCase(f) {
        let s = f.replace(/([^A-Z])([A-Z])/g, '$1 $2');
        s = s.charAt(0).toUpperCase() + s.slice(1);
        if (s.startsWith('Dc ')) {
            s = "DC " + s.slice(3);
        } else if (s.startsWith('Ac ')) {
            s = "AC " + s.slice(3);
        } else if (s.endsWith('Dc')) {
            s = s.slice(0, s.length-2) + 'DC';
        } else if (s.endsWith('Ac')) {
            s = s.slice(0, s.length-2) + 'AC';
        }
        return s;
    }

};
